import { Check, MapPin, ShieldCheck } from "lucide-react";
import { CommandItem } from "@/components/ui/command";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import { categoryStyles } from "./recentCustomers";

export function CustomerItem({ customer, isSelected, onSelect, testid }) {
  return (
    <CommandItem
      value={customer.id}
      onSelect={onSelect}
      className="flex items-start gap-3 py-2.5"
      data-testid={testid}
    >
      <Check
        className={cn(
          "w-4 h-4 mt-1 shrink-0",
          isSelected ? "opacity-100 text-primary" : "opacity-0"
        )}
      />
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="font-medium truncate">{customer.company_name}</span>
          {customer.category && (
            <Badge
              variant="secondary"
              className={cn(
                "text-[10px] px-1.5 py-0 h-4 font-medium",
                categoryStyles[customer.category] || ""
              )}
            >
              {customer.category}
            </Badge>
          )}
          {customer.has_maintenance_contract && (
            <ShieldCheck className="w-3.5 h-3.5 text-emerald-600" title="Wartungsvertrag" />
          )}
        </div>
        {(customer.city || customer.postal_code) && (
          <div className="flex items-center gap-1 text-xs text-muted-foreground mt-0.5">
            <MapPin className="w-3 h-3" />
            <span className="truncate">
              {[customer.postal_code, customer.city].filter(Boolean).join(" ")}
            </span>
          </div>
        )}
      </div>
    </CommandItem>
  );
}
